var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    _vm._g(
      _vm._b(
        {
          attrs: { persistent: "", fullscreen: _vm.smallScreen, width: "60%" },
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.$scopedSlots, function(_, slot) {
                return {
                  key: slot,
                  fn: function(scope) {
                    return [_vm._t(slot, null, { open: _vm.open }, scope)]
                  }
                }
              })
            ],
            null,
            true
          ),
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        "v-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "v-container",
        { staticClass: "white py-0" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass:
                    "modal-title white--text d-flex justify-space-between align-center",
                  attrs: { cols: "12" }
                },
                [
                  _c(
                    "h3",
                    { staticClass: "d-flex align-center font-weight-regular" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-3", attrs: { dark: "" } },
                        [_vm._v("mdi-account-details")]
                      ),
                      _vm._v("Perfil ")
                    ],
                    1
                  ),
                  _c(
                    "v-icon",
                    {
                      attrs: { dark: "" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v("mdi-close")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-1" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-flex justify-space-between align-center"
                        },
                        [
                          _c("h2", [
                            _vm._v(
                              _vm._s(_vm.user.name) +
                                " " +
                                _vm._s(_vm.user.lastName)
                            )
                          ]),
                          !_vm.smallScreen
                            ? _c(
                                "v-icon",
                                {
                                  staticClass: "modifyAction",
                                  attrs: { color: "rgb(25, 58, 81)" },
                                  on: {
                                    click: function($event) {
                                      _vm.modify = !_vm.modify
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getIcon))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-row",
                    { staticClass: "ma-1 mb-0", attrs: { justify: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "1", xl: "3" } }),
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              value: _vm.user.ci,
                              label: "Cédula de identidad",
                              "prepend-icon": "mdi-card-account-details",
                              readonly: ""
                            }
                          }),
                          _c("v-text-field", {
                            attrs: {
                              value: _vm.user.company,
                              label: "Empresa",
                              readonly: "",
                              "prepend-icon": "mdi-office-building"
                            }
                          }),
                          _c("phone-field", {
                            ref: "secondaryPhone",
                            attrs: {
                              label: "Teléfono secundario",
                              readonly: !_vm.modify,
                              "phone-data": _vm.user.cellphone
                            },
                            on: {
                              "update:phoneData": function($event) {
                                return _vm.$set(_vm.user, "cellphone", $event)
                              },
                              "update:phone-data": function($event) {
                                return _vm.$set(_vm.user, "cellphone", $event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "1" } }),
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Correo electrónico",
                              rules: [_vm.rules.required(), _vm.rules.email()],
                              "append-outer-icon": _vm.modify
                                ? "mdi-pencil"
                                : "",
                              readonly: !_vm.modify,
                              required: "",
                              "prepend-icon": "mdi-at"
                            },
                            model: {
                              value: _vm.user.email,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "email", $$v)
                              },
                              expression: "user.email"
                            }
                          }),
                          _c("phone-field", {
                            ref: "primaryPhone",
                            attrs: {
                              label: "Teléfono primario",
                              readonly: !_vm.modify,
                              "phone-data": _vm.user.phone
                            },
                            on: {
                              "update:phoneData": function($event) {
                                return _vm.$set(_vm.user, "phone", $event)
                              },
                              "update:phone-data": function($event) {
                                return _vm.$set(_vm.user, "phone", $event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "1", xl: "3" } })
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.modify,
                          expression: "modify"
                        }
                      ],
                      staticClass: "ma-1",
                      attrs: { justify: "center" }
                    },
                    [
                      _c("v-col", { attrs: { cols: "1", xl: "3" } }),
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-expansion-panels",
                            { attrs: { accordion: "" } },
                            [
                              _c(
                                "v-expansion-panel",
                                [
                                  _c(
                                    "v-expansion-panel-header",
                                    { staticClass: "subtitle-1" },
                                    [_vm._v("Cambiar contraseña")]
                                  ),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form1",
                                          attrs: { id: "form1" },
                                          on: {
                                            submit: function($event) {
                                              $event.preventDefault()
                                            }
                                          },
                                          model: {
                                            value: _vm.valid,
                                            callback: function($$v) {
                                              _vm.valid = $$v
                                            },
                                            expression: "valid"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                [
                                                  _c(
                                                    "v-text-field",
                                                    {
                                                      attrs: {
                                                        autocomplete: "off",
                                                        autofocus: "",
                                                        rules: [
                                                          _vm.rules.required(),
                                                          _vm.rules.noSpacesAllowed(),
                                                          _vm.rules.fieldMinLength(
                                                            8
                                                          )
                                                        ],
                                                        "error-messages":
                                                          _vm.passwordsMatch,
                                                        "append-icon": _vm.showPassword
                                                          ? "mdi-eye"
                                                          : "mdi-eye-off",
                                                        type: _vm.showPassword
                                                          ? "text"
                                                          : "password",
                                                        label:
                                                          "Nueva contraseña",
                                                        "single-line": "",
                                                        counter: "",
                                                        maxlength: "30",
                                                        required: ""
                                                      },
                                                      on: {
                                                        "click:append": function(
                                                          $event
                                                        ) {
                                                          _vm.showPassword = !_vm.showPassword
                                                        }
                                                      },
                                                      model: {
                                                        value: _vm.password,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.password = $$v
                                                        },
                                                        expression: "password"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        {
                                                          slot: "prepend-inner"
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-account-lock"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-col", {
                                                attrs: { cols: "1" }
                                              }),
                                              _c(
                                                "v-col",
                                                [
                                                  _c(
                                                    "v-text-field",
                                                    {
                                                      attrs: {
                                                        "append-icon": _vm.showConfirmationPassword
                                                          ? "mdi-eye"
                                                          : "mdi-eye-off",
                                                        type: _vm.showConfirmationPassword
                                                          ? "text"
                                                          : "password",
                                                        rules: [
                                                          _vm.rules.required()
                                                        ],
                                                        disabled:
                                                          !_vm.password ||
                                                          _vm.password === " ",
                                                        label:
                                                          "Confirme su nueva contraseña",
                                                        "single-line": "",
                                                        counter: "",
                                                        maxlength: "30",
                                                        autocomplete: "off",
                                                        required: ""
                                                      },
                                                      on: {
                                                        "click:append": function(
                                                          $event
                                                        ) {
                                                          _vm.showConfirmationPassword = !_vm.showConfirmationPassword
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.confirmationPassword,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.confirmationPassword = $$v
                                                        },
                                                        expression:
                                                          "confirmationPassword"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        {
                                                          slot: "prepend-inner"
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-account-lock"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "1", xl: "3" } })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "span",
                  { staticClass: "d-flex justify-end" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "mx-2",
                        attrs: { color: "green", outlined: "" },
                        on: {
                          click: function($event) {
                            _vm.dialog = false
                          }
                        }
                      },
                      [_vm._v("Salir")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mx-2 white--text",
                        class: { "d-none": !_vm.modify },
                        attrs: { color: "green", loading: _vm.isSaving },
                        on: {
                          click: function($event) {
                            return _vm.save()
                          }
                        }
                      },
                      [_vm._v("Guardar cambios")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }